/**
 * 基础菜单 商品管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>电话订单</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" ref="formInline" :model="formInline" class="user-search">
      <el-form-item prop="accountId" label="咨询人ID:">
        <el-input maxlength=11 clearable v-model="formInline.accountId" placeholder="输入红娘ID"></el-input>
      </el-form-item>
      <el-form-item label="咨询人昵称:" prop="nickName">
        <el-input maxlength="10" clearable v-model="formInline.nickName" placeholder="输入咨询人昵称"></el-input>
      </el-form-item>


      <el-form-item prop="phone" label="注册手机号码:">
        <el-input maxlength=11 clearable v-model="formInline.phone" placeholder="输入手机号码"></el-input>
      </el-form-item>
      <el-form-item prop="inputPhone" label="填写手机号码:">
        <el-input maxlength=11 clearable v-model="formInline.inputPhone" placeholder="输入填写手机号码"></el-input>
      </el-form-item>
      <el-form-item prop="payType" label="支付类型">
        <el-select v-model="formInline.payType" placeholder="不限">
          <el-option label="不限" value=""></el-option>
          <el-option label="微信支付" value="1"></el-option>
          <el-option label="在线支付" value="2"></el-option>
          <el-option label="抖音支付" value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="sex" label="咨询人性别:">
        <el-select v-model="formInline.sex" placeholder="不限">
          <el-option label="不限" value=""></el-option>
          <el-option label="男" value="1"></el-option>
          <el-option label="女" value="2"></el-option>

        </el-select>
      </el-form-item>
      <el-form-item prop="joinType" label="会员类型:">
        <el-select v-model="formInline.joinType" placeholder="不限">
          <el-option label="不限" value=""></el-option>
          <el-option label="咨询免费会员" value="2"></el-option>
          <el-option label="咨询付费会员" value="1"></el-option>

        </el-select>
      </el-form-item>

      <el-form-item prop="registerType" label="注册类型">
        <el-select v-model="formInline.registerType" placeholder="不限">
          <el-option label="不限" value=""></el-option>
          <el-option v-for="item in PlatformTypeOptions" :label="item.label" :value="item.value"
                     :key="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="status" label="订单状态:">
        <el-select v-model="formInline.status" placeholder="不限">
          <el-option label="不限" value=""></el-option>
          <el-option label="待受理" value="2"></el-option>
          <el-option label="已预约" value="3"></el-option>
          <el-option label="待确定" value="5"></el-option>
          <el-option label="已结束" value="6"></el-option>

        </el-select>
      </el-form-item>
      <el-form-item prop="callTimeLength" label="通话时长:">
        <el-select v-model="formInline.callTimeLength" placeholder="不限">
          <el-option label="不限" value=""></el-option>
          <el-option label="1-30分" value="1"></el-option>
          <el-option label="31-60分" value="2"></el-option>
          <el-option label="60分及以上" value="3"></el-option>

        </el-select>
      </el-form-item>
      <el-form-item prop="isVip" label="vip类型:">
        <el-select v-model="formInline.isVip" placeholder="不限">
          <el-option label="不限" value=""></el-option>
          <el-option label="线下超级会员" value="1"></el-option>
          <el-option label="线上VIP" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="teacherId" label="红娘导师:">

        <el-select clearable v-model="formInline.teacherId" placeholder="请选择红娘导师">
          <el-option

            v-for="item in options123"
            :key="item.code"
            :label="item.desc"
            :value="item.code">
          </el-option>
        </el-select>


        <!-- <el-input  clearable v-model="formInline.name" placeholder="请输入红娘导师"></el-input> -->
      </el-form-item>


      <el-form-item prop="createBeginTime" label="支付时间">
        <el-col :span="11">
          <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期"
                          v-model="formInline.createBeginTime" style="width: 100%;"></el-date-picker>
        </el-col>
        <el-col class="line" :span="2">&nbsp;&nbsp;&nbsp;&nbsp;-</el-col>
        <el-col :span="11">
          <el-form-item prop="createEndTime" label="">
            <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" default-time="['23:59:59']" type="datetime"
                            placeholder="选择日期" v-model="formInline.createEndTime"
                            style="width: 100%;"></el-date-picker>

          </el-form-item>

        </el-col>
      </el-form-item>


      <div style=" float: right; margin-right: 50px;  ">
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button icon="el-icon-delete" type="info" @click="resetForm('formInline')">重置</el-button>
        <!-- <el-button  type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      <el-button @click="resetForm('formInline')">重置</el-button> -->

      </div>
    </el-form>

    <!--列表-->
    <el-table id="educe-table" ref="multipleTable" @selection-change="handleSelectionChange" stripe :data="listData"
              highlight-current-row v-loading="loading"

              @select-all="selectall" @select="select" border element-loading-text="拼命加载中"
              style="width: 100%; font-size: 20px;">
      <el-table-column @select-all="selectall" align="center" type="selection" width="60">
      </el-table-column>
      <el-table-column align="center" prop="accountId" label="咨询人ID" width="150">
        <template slot-scope="scope">
          <img style="width:60%;" v-if="scope.row.isVip==1"
               src="https://test-cos.ynhlminiapp.com/ae6990bf-1687-4fee-b1c4-f579d5caf927.png" alt=""><br>
          <span style="font-size: 30px; font-weight: 600; color: #8F5BE7;">{{ scope.row.accountId }}</span>
          <img v-if="scope.row.isJoinVipClub==1" style="width: 90px; height: 30px; margin-top: 10px;"
               src="https://online-miniapp-1304146125.cos.ap-beijing.myqcloud.com/a3c71c1d-165d-4688-9db4-0f63541cab90.png"
               alt="">
          <br><span v-if="scope.row.isMember==1" style="width: 90px; height: 30px; margin-top: 10px; color: red; font-size: 12px" >线上VIP</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="image" label="咨询人头像" width="150">
        <template slot-scope="scope">
          <el-image style="width: 120px; height: 100px; border-radius: 10px;" :src="scope.row.headIcon"
                    :preview-src-list="[scope.row.headIcon]"/>
        </template>
      </el-table-column>
      <el-table-column prop="image" label="咨询人信息" width="250">
        <template slot-scope="scope">
          <span>昵称:{{ scope.row.nickName }}</span><br>
          <span>年龄:{{ scope.row.age }}岁/{{ scope.row.sex == 1 ? '男' : '女' }}</span><br>
          <span>学历:{{ scope.row.educationDesc }}</span><br>
          <span>月收入:{{ scope.row.monthlyIncomeDesc }}</span><br>
          <span>居住地:{{ scope.row.loginAddress }}</span><br>
        </template>
      </el-table-column>
      <el-table-column prop="platformType" align="center" label="支付类型" width="150">
        <template slot-scope="scope">
          <span v-if="scope.row.payType==1">微信支付 </span>
          <span v-if="scope.row.payType==2">在线支付</span>
          <span v-if="scope.row.payType==3">抖音支付</span>

        </template>
      </el-table-column>
      <el-table-column prop="registerTimeMills" label="注册时间" width="250">
        <template slot-scope="scope">
          <div>{{ scope.row.registerTimeMills|timestampToTime }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="payTimeMills" label="支付时间" width="250">
        <template slot-scope="scope">
          <div>{{ scope.row.payTimeMills|timestampToTime }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="phone" label="注册手机号码" width="150">
        <template slot-scope="scope">
          <div>{{ scope.row.phone }}</div>

        </template>
      </el-table-column>
      <el-table-column prop="inputPhone" label="填写手机号码" width="150">
        <template slot-scope="scope">
          <div>{{ scope.row.inputPhone }}</div>

        </template>
      </el-table-column>
      <el-table-column prop="remark" style="background-color: #ccc;" label="申请描述" width="250">
      </el-table-column>
      <el-table-column align="center" prop="teacherId" label="红娘ID" width="100">
      </el-table-column>
      <el-table-column align="center" prop="sex" label="导师信息" width="200">
        <template slot-scope="scope">
          <el-image style="width: 120px; height: 100px; border-radius: 10px;" :src="scope.row.image"
                    :preview-src-list="[scope.row.image]"/>
          <br>
          <span>{{ scope.row.name }}({{ scope.row.realName }})</span><br>
          <el-tag type="success">{{ scope.row.title }}</el-tag>

        </template>
      </el-table-column>
      <el-table-column align="center" prop="joinType" label="会员类型" width="150">
        <template slot-scope="scope">
          <el-tag v-if=" scope.row.joinType==1" type="success">咨询付费会员</el-tag>
          <el-tag v-if=" scope.row.joinType==2" type="warning">咨询免费会员</el-tag>


        </template>
      </el-table-column>
      <el-table-column align="center" prop="amount" label="咨询费用" width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.amount>0">¥{{ scope.row.amount }}</span>
          <span v-if="scope.row.amount==0">免费</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="minutes" label="咨询分钟" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.minutes }}分</span>


        </template>
      </el-table-column>
      <el-table-column align="center" prop="payStatus" label="付费状态" width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.payStatus==1">未付款</span>
          <span v-if="scope.row.payStatus==2">已付款</span>
          <span v-if="scope.row.payStatus==3">已退款</span>
          <span v-if="scope.row.payStatus==4">赠送</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="status" label="账号状态" width="150">
        <template slot-scope="scope">
          <span style="color: #3399FF;" v-if="scope.row.accountStatus==1">正常</span>
          <span style="color: darkgoldenrod;" v-if="scope.row.accountStatus==2">注销中</span>
          <span style="color: red;" v-if="scope.row.accountStatus==3||scope.row.accountStatus==null">已注销</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="status" label="订单状态" width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.status==1">填写信息</span>
          <span v-if="scope.row.status==2">成功支付/待受理</span>
          <span v-if="scope.row.status==3">老师受理/已预约</span>
          <span v-if="scope.row.status==4">开始咨询</span>
          <span v-if="scope.row.status==5">咨询结束/待确认</span>
          <span v-if="scope.row.status==6">已结束</span>
        </template>
      </el-table-column>
      <el-table-column prop="registerTypeDesc" align="center" label="注册类型" width="180">
      </el-table-column>
      <el-table-column prop="createTimeMills" label="订单时间" width="250">
        <template slot-scope="scope">
          <div>{{ scope.row.createTimeMills|timestampToTime }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="callBeginTimeMills" label="通话时长" width="300">
        <template slot-scope="scope">
          <div v-if="scope.row.callBeginTimeMills">开始时间:{{ scope.row.callBeginTimeMills|timestampToTime }}</div>
          <div v-if="!scope.row.callBeginTimeMills">开始时间:</div>
          <div v-if="scope.row.callEndTimeMills">结束时间:{{ scope.row.callEndTimeMills|timestampToTime }}</div>
          <div v-if="!scope.row.callEndTimeMills">结束时间:</div>
          <div>通话时长:{{ scope.row.callTimeSecond == 0 ? '' : scope.row.callTimeSecond }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="callBeginTimeMills" fixed="right" align="center" label="通话次数" width="120">
        <template slot-scope="scope">
          <h1 style="color: #885DDF;" @click="Numbercalls(scope.row)">{{ scope.row.callNum }}</h1>
          <!-- <el-button type="success" @click="Numbercalls">次数</el-button> -->
          <!-- <el-button v-if="scope.row.status==2" type="primary"  @click="oncloseDialog(scope.row)">操作</el-button>
          <el-button v-if="scope.row.status==3||scope.row.status==4||scope.row.status==5" type="success"  @click="oncloseDialog(scope.row)">编辑</el-button>
          <el-button v-if="scope.row.status==6" >已结束</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" style="float: right; margin-right:0px; height: 50px; margin-top: 50px;"
                @size-change="handleSizeChange" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <div style="margin-top: 20px; position: fixed; bottom: 50px; left: 300px;"
         v-if="roleId.roleId==1||roleId.roleId==2">
      <el-button v-if="ifShowbar==1" @click="selectalls(listData)" type="primary">全选</el-button>
      <el-button v-if="ifShowbar==2" @click="selectallsif(listData)" type="primary">反选</el-button>
      <el-button @click="imporList" type="success">导出数据</el-button>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <span>确定导出用户数据？</span>
      <span slot="footer" class="dialog-footer">
    <el-button @click="falseDialogVisible">取 消</el-button>
    <el-button type="primary" @click="dialogVisiblexel">确 定</el-button>
  </span>
    </el-dialog>
    <el-dialog
      title="通话次数"
      :visible.sync="centerDialogVisible"
      width="60%"
      center>

      <el-table
        :data="tableData"
        :border="true"
        style="width: 100%">
        <el-table-column
          type="index"
          label="排序"
          width="180">
        </el-table-column>

        <el-table-column
          prop="userId"
          label="导师ID"
          width="180">
        </el-table-column>
        <el-table-column
          prop="teacherName"
          label="呼出导师">
        </el-table-column>
        <el-table-column
          prop="mid"
          label="客户MID">
        </el-table-column>
        <el-table-column
          prop="dialingTime"
          label="呼叫时间">
        </el-table-column>
        <el-table-column
          prop="answerTime"
          label="通话开始时间">
        </el-table-column>
        <el-table-column
          prop="hangupTime"
          label="通话结束时间">
        </el-table-column>
        <el-table-column
          prop="answerCallDuration"
          label="通话时长">
          <template #default="scope">

            <span v-if="scope.row.answerCallDuration">{{ scope.row.answerCallDuration }}分钟</span>
          </template>
        </el-table-column>
      </el-table>


      <span slot="footer" class="dialog-footer">
    <el-button type="primary" @click="centerDialogVisible = false">知道了</el-button>
  </span>
    </el-dialog>
    <!-- <el-dialog  :destroy-on-close='true' @close="mVisiblefalse" :close-on-click-modal="false" title="请选择订单状态" :visible.sync="dialogFormVisible">
      <el-form   :rules="rules" ref="ruleForm"  :model="form">
        <el-form-item prop="updateType" label="状态:">
        <el-radio-group   v-model="form.updateType">

          <el-radio label="1">预约时间</el-radio>
          <el-radio  v-if="statusif>=3" label="2">订单确定</el-radio>
        </el-radio-group>
      </el-form-item>

      <span v-if="form.updateType==1" >请受理订单，并输入与用户预约时间</span>
          <el-form-item  v-if="form.updateType==1" style="margin-top: 50px;"  prop="applyTime" label="预约时间">
            <el-date-picker    type="datetime" placeholder="选择日期" v-model="form.applyTime" style="width: 30%;"></el-date-picker>
          </el-form-item>
          <span v-if="form.updateType==2" style="color: red;" >请输入通话开始/结束时间，确认无误保存结束订单，通话开始时间不能早于预约时间，通话结束时间不能早于通话开始时间</span>
          <el-form-item v-if="form.updateType==2" style="margin-top: 50px;"  prop="callBeginTime" label="通话开始时间">
            <el-date-picker       type="datetime" placeholder="选择日期" v-model="form.callBeginTime" style="width: 30%;"></el-date-picker>
          </el-form-item>
          <el-form-item v-if="form.updateType==2" style="margin-top: 50px;"  prop="callEndTime" label="通话结束时间">
            <el-date-picker        type="datetime" placeholder="选择日期" v-model="form.callEndTime" style="width: 30%;"></el-date-picker>
          </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="mVisiblefalse">取 消</el-button>
        <el-button type="primary" @click="ondialogFormVisible('ruleForm')">确 定</el-button>
      </div>
    </el-dialog> -->

  </div>
</template>

<script>
import Vue from 'vue'
import { deptList, deptSave,deptDelete} from '../../api/userMG'
import Axios from 'axios'
import {mobileStr}from "../../utils/util"
import Pagination from '../../components/Pagination'
import {PlatformTypeOptions} from "../../enums/userEnum";

export default {
  computed: {
    PlatformTypeOptions() {
      return PlatformTypeOptions
    }
  },
  data() {
    return {
      statusif: '',
      userifom: "",
      ssoServer: "",
      centerDialogVisible: false,
      form: {

        updateType: "",
        applyTime: "",
        callBeginTime: "",
        callEndTime: '',
        id: ''

      },
      tableData: [],
      addtitle:'全选',
      dialogVisible: false,
      ifindex:'',
      dialogFormVisible:false,
      options123 : [],
      options1234123:[],
      resource:'',
      forlist:[],
      importListsss:'',
      formLabelWidth: '120px',
      ifShowbar:1,
      adder:"",

      nshow: true, //switch开启
      fshow: false, //switch关闭
      importList:[],
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加',

      editForm: {
        deptId: '',
        deptName: '',
        deptNo: '',
        token: localStorage.getItem('logintoken')
      },

      // rules表单验证
      rules: {
        callEndTime:[{required: true, message: '通话结束时间不能为空', trigger: 'blur'}],
        callBeginTime:[{required: true, message: '通话开始时间不能为空', trigger: 'blur'}],
        applyTime:[{required: true, message: '预约时间不能为空', trigger: 'blur'}],
        updateType:[{ required: true, message: '状态不能为空', trigger: 'blur' }],
        deptName: [
          { required: true, message: '请输入部门名称', trigger: 'blur' }
        ],
        deptNo: [{ required: true, message: '请输入部门代码', trigger: 'blur' }]
      },
      formInline: {
        registerType: "",
        isVip: "",
        platformType: "",
        callTimeLength: '',
        joinType: "",
        status: "",
        inputPhone: '',
        sex: '',
        accountId: '',
        createBeginTime: "",
        createEndTime: '',
        name: '',
        nickName: '',
        phone: '',
        id: '',
        teacherId: '',
        current: 1,
        size: 20,
        // token: localStorage.getItem('logintoken')
      },
      roleId:"",
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 20,
        total: 10
      }
    }
  },

  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.roleId=JSON.parse(localStorage.getItem('userlist'))
    this.ssoServer = Vue.prototype.GLOBAL.ssoServer
    let tokenId= localStorage.getItem('tokenId');
    this.adder =tokenId



    // this.getdata(this.formInline)
  },
   mounted(){
    this.formLIst()
    this.getAddress()
    this.userifom= localStorage.getItem('userifom');



   },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
// 通话次数
    Numbercalls(item){
      console.log(item);
      this.tableData=item.callNumDetails
   this.centerDialogVisible=true
    },
    mVisiblefalse(){
     this.dialogFormVisible=false
     this.form.updateType=''
     this.form.applyTime=''
     this.form.callBeginTime=''
     this.form.callEndTime=''
    },
    ondialogFormVisible(formName){
      // const startTime = new Date(this.form.applyTime).getTime()
 const endTimes = new Date(this.form.callBeginTime).getTime()
 const callEndTime = new Date(this.form.callEndTime).getTime()

      if(callEndTime<endTimes){
 this.$message({
message: '通话结束时间不得早于通话开始时间',
type: 'warning'});return
}



if(!this.form.applyTime){
 this.$message({
message: '预约时间不得为空',
 type: 'warning'
});
return
 }

 const startTime = new Date(this.form.applyTime).getTime()
 const endTime = new Date(this.form.callBeginTime).getTime()

  // if(startTime>endTime){
  //  this.$message({
  // message: '通话开始时间不得早于预约时间',
  // type: 'warning'
  //  });
  //  return
  // }

      this.$refs[formName].validate((valid) => {
          if (valid) {
        Axios({
        method: 'post',
        url: this.ssoServer+'/api/phone-order/update',
        headers:{
          tokenId:this.adder
        },
        data:this.form

      }).then(res => {

        if(res.data.code==999){
          setTimeout(() => {
            localStorage.removeItem('tokenId')

            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '登录过期,请重新登录'
            })
          }, 1000)
        }else if(res.data.code==0){
          this.dialogFormVisible=false
          this.$message({
              type: 'success',
              message: '修改成功'
            })
            // this.statusif=''
            this.form.updateType=''

            this.formLIst()
               this.form.applyTime=''
        this.form.callBeginTime=''
        this.form.callEndTime=''


        }else{

          this.$message({
              type: 'warning',
              message: res.data.message
            })
        }

        console.log(res);

      })
            // alert('submit!');
          } else {
            console.log('error submit!!');
            return false;
          }
        });




    },

    oncloseDialog(row){
      this.statusif =row.status

      this.form.id=row.id
      this.dialogFormVisible=true



      if(row.status==5){
        this.form.updateType='2'
        this.form.applyTime =row.applyTimeStr
        this.form.callBeginTime=row.callBeginTimeStr
        this.form.callEndTime=row.callEndTimeStr


      }else if(row.status==3){
        this.form.updateType='1'
        // console.log(row.applyTimeMills);
        this.form.callBeginTime=row.callBeginTimeStr
        this.form.callEndTime=row.callEndTimeStr
        this.form.applyTime =row.applyTimeStr

      }
      // console.log(row);
      // this.form.updateType=row.status




    },
    ongetAddress(){
      Axios({
        method: 'get',
        url: this.ssoServer+'/api/source-config/getList',
        headers:{
          tokenId:this.adder
        },
      }).then(res => {
        console.log(res);
        this.forlist =res.data.data
        // this.options123 = res.data.data

      })

    },

    falseDialogVisible(){
      // this.importList=[]
      this.dialogVisible=false

    },
    dialogVisiblexel(){


      const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
          Axios({
 method: 'post',

 url: this.ssoServer+'/api/phone-order/export',
 headers:{
  tokenId:this.adder
        },
 data: {
    ids: this.importListsss,

 },
 responseType: 'blob'
}).then(res => {
 const link = document.createElement('a') // 创建a标签
 const blob = new Blob([res.data], { type: 'application/vnd.ms-excel;charset=UTF-8' })
 link.href = window.URL.createObjectURL(blob)
 const filename = '电话订单列表'
 link.download = decodeURIComponent(filename) // 如果需要自定义下载文件名，则手动设置
 link.click()
 window.URL.revokeObjectURL(link.href)
})
             this.dialogVisible=false
          loading.close();
        }, 500);




    },


    selectall(val){
        // console.log(val);

      let data =[]
      // this.importList=''
      val.forEach((item)=>{
        data.push(item.id)
        this.importListsss =data
        console.log(this.importList);

      })

      // this.importList
    // console.log(val);
    },


    getAddress(){

      Axios({
        method: 'get',
        url: this.ssoServer+'/api/teacher/teacherList',

        headers:{
          tokenId:this.adder
        }
      }).then(res => {
        if(res.data.code==999){
          setTimeout(() => {
            localStorage.removeItem('tokenId')

            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '登录过期,请重新登录'
            })
          }, 1000)
        }
        console.log("getAddressList", res.data.data);
        this.options123 = res.data.data

      })
    },

    getAddresss(){
      Axios({
        method: 'get',
        url: this.ssoServer+'/api/common/getAddressList1',
        headers:{
          tokenId:this.adder
        }
      }).then(res => {
        if(res.data.code==999){
          setTimeout(() => {
            localStorage.removeItem('tokenId')

            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '登录过期,请重新登录'
            })
          }, 1000)
        }
        // console.log("getAddressList", res.data.data);
        this.options1234123 = res.data.data

      })
    },

    change1(e){
      console.log("change1", e);
      if(e.length === 1){
        this.$message({
          type: 'error',
          message: '请选择详细地址'
        })
      }
      if(e.length === 2){
        this.formInline.registerAddress=e[1];
      }
    },


    selectallsif(){
      this.ifShowbar=1
      this.$refs.multipleTable.clearSelection();//清除全选
      this.importList=[]
    },

    selectalls(rows) {


      if (rows) {
        let data =[]
        rows.forEach((item)=>{
        data.push(item.id)
        this.importListsss =data
        console.log(this.importList);

      })
        rows.forEach(row => {

          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        // console.log('1212112');
        this.importList=[]
        this.$refs.multipleTable.clearSelection();//清除全选
      }
       this.ifShowbar=2


    },

              onChange(e){

                this.formInline.registerAddress=e[1]
                  // console.log( this.formInline.registerAddress);


              },
              onChanges(e){
                this.formInline.registerIpAddress=e[1]
                  // console.log( this.formInline.registerAddress);
              },
    // selectall(val){

    //   let data =[]
    //   val.forEach((item)=>{
    //     data.push(item.id)
    //     this.importList =data
    //     console.log(this.importList);

    //   })

    //   // this.importList
    // console.log(val);
    // },
    handleSelectionChange(val) {
        this.importList = val;
      },
    // 导出数据
    imporList(){

      if(this.importList.length==0){
        this.$message({
          type: 'warning',
          message: '请选择要导出的数据'
        })
        return

      }else{
        this.dialogVisible=true
      }









//       if(this.importList.length==0){

//        this.$message({
//          type: 'warning',
//          message: '请选择要导出的数据'
//        })
//        return

//      }else{
//              Axios({
//  method: 'post',

//  url: this.ssoServer+'/api/platform-account/exportExcel',
//  headers:{
//   tokenId:this.adder
//         },
//  data: {

//    accountIds: this.importList,
//    searchType:1
//  },
//  responseType: 'blob'
// }).then(res => {
//  const link = document.createElement('a') // 创建a标签
//  const blob = new Blob([res.data], { type: 'application/vnd.ms-excel;charset=UTF-8' })
//  link.href = window.URL.createObjectURL(blob)
//  const filename = '预注册列表'
//  link.download = decodeURIComponent(filename) // 如果需要自定义下载文件名，则手动设置
//  link.click()
//  window.URL.revokeObjectURL(link.href)
// })


//      }




    },
    select(selection, row){

      let data =[]
      // this.importList=''
      selection.forEach((item)=>{
        data.push(item.id)
        this.importListsss =data
        console.log(this.importList);

      })

      // console.log(this.importList);
      // console.log(selection);
    },
    resetForm(formInline) {
  //  this.formInline =''
        this.$refs[formInline].resetFields();
      },


    formLIst(){

      // let accountListReqVO= this.formInline
      Axios({
  method: 'get',

  url: this.ssoServer+'//api/phone-order/getList',
  headers:{
          tokenId:this.adder
        },
  params:this.formInline


}).then(res=>{
  if(res.data.code==999){
          setTimeout(() => {
            localStorage.removeItem('tokenId')

            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '登录过期,请重新登录'
            })
          }, 1000)
        }else if(res.data.code==500){
          this.$message({
              type: 'warning',
              message: res.data.message
            })
        }
  this.listData =res.data.data.list

      this.pageparm.currentPage = this.formInline.current
      this.pageparm.pageSize = this.formInline.size
      this.pageparm.total = res.data.data.total
  console.log(res);
})

    },
    formatData(row, column, cellValue, index){

		//把传过来的日期进行回炉重造一下，又创建了一个js的 Date对象，进行重新构造，转为String字符串
		//最终返回 s 就可以了
		var s =	new Date(cellValue).toLocaleString();
	    return s;

		  // 测试参数含义：不知道参数是什么含义的就打印出来
		  // console.log(row)     	//拿到一行的所有信息，要拿到具体信息,只需要row.XXX 就可以了
		  // console.log(column)  	//拿到列的信息
		  // console.log(cellValue) //拿到单元格数据，拿到时间 2022-03-18T01:46:08.000+00:00
		  // console.log(index)     //拿到索引
	    },

    // 获取公司列表
    getdata(parameter) {
      this.loading = true
      // 模拟数据开始
      let res = {
        code: 0,
        msg: null,
        count: 5,
        data: [
          {
            addUser: null,
            editUser: null,
            addTime: 1521062371000,
            editTime: 1526700200000,
            deptId: 2,
            deptName: 'XX分公司',
            deptNo: '1',
            parentId: 1
          },
          {
            addUser: null,
            editUser: null,
            addTime: 1521063247000,
            editTime: 1526652291000,
            deptId: 3,
            deptName: '上海测试',
            deptNo: '02',
            parentId: 1
          },
          {
            addUser: null,
            editUser: null,
            addTime: 1526349555000,
            editTime: 1526349565000,
            deptId: 12,
            deptName: '1',
            deptNo: '11',
            parentId: 1
          },
          {
            addUser: null,
            editUser: null,
            addTime: 1526373178000,
            editTime: 1526373178000,
            deptId: 13,
            deptName: '5',
            deptNo: '5',
            parentId: 1
          },
          {
            addUser: null,
            editUser: null,
            addTime: 1526453107000,
            editTime: 1526453107000,
            deptId: 17,
            deptName: 'v',
            deptNo: 'v',
            parentId: 1
          }
        ]
      }
      this.loading = false

      // 模拟数据结束

      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      deptList(parameter)
    },
    handleSizeChange(e){
      // reru console.log(e.pageSize);
      this.formInline.size =e.pageSize
      this.formInline.current = e.currentPage

      this.formLIst()
    // console.log(e);
    },
    // 分页插件事件
    callFather(parm) {
      console.log(parm);

      this.formInline.size = parm.pageSize
      this.formInline.current = parm.currentPage
      this.formLIst()
    },
    // 搜索事件
    search() {
      this.formInline.current=1
      // if(this.formInline.beginAge<18){
      //   this.$message({
      //             type: 'warning',
      //             message: '年龄不能小于18'
      //           })
      //           return

      // }else if(this.formInline.endAge>80){
      //   this.$message({
      //             type: 'warning',
      //             message: '年龄不能大于80'
      //           })
      //           return
      // }

this.formLIst()

      // console.log(this.formInline);
      // this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        this.editForm.deptId = row.deptId
        this.editForm.deptName = row.deptName
        this.editForm.deptNo = row.deptNo
      } else {
        this.title = '添加'
        this.editForm.deptId = ''
        this.editForm.deptName = ''
        this.editForm.deptNo = ''
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          deptSave(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.success) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '公司保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('公司保存失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
    // async logins() {
    //     // 网络请求
    //     let data = await login('1111111');
    //     // let token = data.token;
    //     // 本地  vuex
    //     // this.$store.commit('LOGIN_IN',token);
    //     this.$router.replace("/")
    // },

    // 删除公司
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deptDelete(row.deptId)
            .then(res => {
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: '公司已删除!'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('公司删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
  /* font-size: 30px; */
}
.userRole {
  width: 100%;
}
</style>





// WEBPACK FOOTER //
// src/views/Mentor/PhoneOrders.vue